import React, { useEffect, useState } from 'react';
import { MdContentCopy, MdCheck } from 'react-icons/md';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { RootState } from '../../app/store';
import { GetApiKeys } from '../../features/partnerSlice';

const ApiKeys = () => {
  const dispatch = useAppDispatch();
  const apiKeysData = useAppSelector(
    (state: RootState) => state.partner.apiKeysData
  );

  const programCodeValue = apiKeysData?.referralCode ?? '';
  const xApiKeyValue = apiKeysData?.xApiKey ?? apiKeysData?.['x-api-key'] ?? '';
  const encryptionKeyValue =
    apiKeysData?.encryptionKey ?? apiKeysData?.['encryption_key'] ?? '';

  const [copiedField, setCopiedField] = useState<
    'x-api-key' | 'encryption' | 'program-code' | null
  >(null);

  const copyToClipboard = (
    value: string,
    field: 'x-api-key' | 'encryption' | 'program-code' 
  ) => {
    if (!value) return;
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value);
      setCopiedField(field);
      setTimeout(() => setCopiedField(null), 1500);
    }
  };

  useEffect(() => {
    dispatch(GetApiKeys());
  }, [dispatch]);

  return (
    <>
      <div className='justify-center max-w-full rounded-lg primary-shadow'>
        <div className='bg-white rounded-lg w-full'>
          <div className='mb-8'>
            <div className='mb-6 pb-4'>
              <h2 className='text-white bg-primary p-4 px-8 rounded-t-lg text-lg font-semibold'>
                API Keys
              </h2>
              <div className='p-4 md:p-8'>
                <p className='text-sm md:text-base text-[#343434] mb-4'>
                  Manage your API keys for program integrations.
                </p>

                {/* Read-only fields with copy icon */}
                <div className='grid grid-cols-1 xmd:grid-cols-2 gap-4 mb-4'>
                  <div>
                    <label className='block text-xs font-semibold text-[#555] mb-1'>
                      x-api-key
                    </label>
                    <div className='flex items-center h-[48px]'>
                      <input
                        type='text'
                        readOnly
                        value={xApiKeyValue}
                        className='register-input flex-1 rounded-r-none text-sm h-full'
                      />
                      <button
                        type='button'
                        onClick={() =>
                          copyToClipboard(xApiKeyValue, 'x-api-key')
                        }
                        className={`h-full w-11 flex items-center justify-center rounded-r ${
                          copiedField === 'x-api-key'
                            ? 'bg-secondary text-white'
                            : 'bg-[#aeaeae] text-white hover:bg-[#9a9a9a]'
                        }`}
                      >
                        {copiedField === 'x-api-key' ? (
                          <MdCheck />
                        ) : (
                          <MdContentCopy />
                        )}
                      </button>
                    </div>
                  </div>

                  <div>
                    <label className='block text-xs font-semibold text-[#555] mb-1'>
                      Encryption Key
                    </label>
                    <div className='flex items-center h-[48px]'>
                      <input
                        type='text'
                        readOnly
                        value={encryptionKeyValue}
                        className='register-input flex-1 rounded-r-none text-sm h-full'
                      />
                      <button
                        type='button'
                        onClick={() =>
                          copyToClipboard(encryptionKeyValue, 'encryption')
                        }
                        className={`h-full w-11 flex items-center justify-center rounded-r ${
                          copiedField === 'encryption'
                            ? 'bg-secondary text-white'
                            : 'bg-[#aeaeae] text-white hover:bg-[#9a9a9a]'
                        }`}
                      >
                        {copiedField === 'encryption' ? (
                          <MdCheck />
                        ) : (
                          <MdContentCopy />
                        )}
                      </button>
                    </div>
                  </div>
                </div>

                <div className='grid grid-cols-1 xmd:grid-cols-2 gap-4 mb-6'>
                  <div>
                    <label className='block text-xs font-semibold text-[#555] mb-1'>
                      Program Code
                    </label>
                    <div className='flex items-center h-[48px]'>
                      <input
                        type='text'
                        readOnly
                        value={programCodeValue}
                        className='register-input flex-1 rounded-r-none text-sm h-full'
                      />
                      <button
                        type='button'
                        onClick={() =>
                          copyToClipboard(programCodeValue, 'program-code')
                        }
                        className={`h-full w-11 flex items-center justify-center rounded-r ${copiedField === 'program-code'
                          ? 'bg-secondary text-white'
                          : 'bg-[#aeaeae] text-white hover:bg-[#9a9a9a]'
                          }`}
                      >
                        {copiedField === 'program-code' ? (
                          <MdCheck />
                        ) : (
                          <MdContentCopy />
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApiKeys;
